export default __webpack_public_path__ + "add0b743808357d9b9c77894219c32c8.png";